export default __webpack_public_path__ + "static/media/2_0094.09aad652.webp";